import { createContext, useContext } from 'react'

export type ShellControls = {
  openPalette: () => void
  openHelp: (tab?: 'help' | 'shortcuts' | 'feedback') => void
}

export const ShellContext = createContext<ShellControls>({ openPalette: () => {}, openHelp: () => {} })

export function useShell(): ShellControls {
  return useContext(ShellContext)
}
